import './BankAccountContainer.css'
import { Skeleton } from '@mantine/core'
import { useFetch } from '../../../hooks/useFetch'
import BankAccount from '../BankAccount/BankAccount'

export default function BankAccountContainer({transferBankAccount}) {
   const { data, isLoading, error } = useFetch(`${process.env.REACT_APP_BACKEND_SERVER}/info/bankAccounts`)
   const {title, errorMessage, transferAccountItemsDolars, transferAccountItemsArgentina} = transferBankAccount;
   
   return (
      <div className='bank-accounts-container'>

         <div className='bank-accounts--anyAccount'>
            <p>{title}</p>
         </div>
         {error && <p style={{ fontSize: '16px' }}>{errorMessage}</p>}
         {isLoading && < Skeleton height={350} />}
         {!isLoading && data && data.map( item => (
            < BankAccount transferAccountItemsDolars={transferAccountItemsDolars} transferAccountItemsArgentina={transferAccountItemsArgentina} key={item._id} account={item} />
         ))
         }
      </div>
   )
}
